import {Injectable} from '@angular/core';
import {HttpClient, HttpHandler, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LoadingIndicatorService} from "./loading-indicator.service";
import {HttpUrlEncodingCodec} from "./http-url-encoding-codec";

declare let iNet: any;

@Injectable()
export class HttpClientService extends HttpClient {
    private headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

    constructor(handler: HttpHandler, private loadingService: LoadingIndicatorService) {
        super(handler);
    }

    convertToHttpParams(obj: any): HttpParams {
        if (!obj) {
            return null;
        }
        return Object.getOwnPropertyNames(obj).reduce((p, key) => p.set(key, obj[key] == undefined ? '' : obj[key]), new HttpParams({encoder: new HttpUrlEncodingCodec()}));
    }

    getJSON(url: string, body?: any | null): Observable<any> {
        return this.get(url, {params: this.convertToHttpParams(body), headers: this.headers});
    }

    postJSON(url: string, body?: any | null): Observable<any> {
        return this.post(url, this.convertToHttpParams(body), {headers: this.headers});
    }

    putJSON(url: string, body?: any | null): Observable<any> {
        return this.put(url, this.convertToHttpParams(body), {headers: this.headers});
    }

    deleteJSON(url: string, body?: any | null): Observable<any> {
        return this.delete(url, {params: this.convertToHttpParams(body), headers: this.headers});
    }

    convertToFormData(obj: any): FormData {
        //console.log('[convertToFormData]', obj);
        let formData = new FormData();
        if (!obj) {
            return formData;
        }
        Object.keys(obj).forEach(k => {
            //console.log('[key]', k , '=', obj[k]==undefined ? '' : obj[k]);
            formData.append(k, obj[k] == undefined ? '' : obj[k]);
        });
        //console.log('[formData]', formData);
        return formData;
    }

    downloadFile(url: string, obj?: any) {
        if (!obj) {
            return;
        }
        let form = document.createElement('form');
        form.method = 'POST';
        form.action = url;
        form.enctype = 'multipart/form-data';

        Object.keys(obj).forEach(k => {
            //console.log('[key]', k , '=', obj[k]==undefined ? '' : obj[k]);
            let input = document.createElement("input");
            input.name = k;
            input.value = obj[k] == undefined ? '' : obj[k];
            input.type = 'hidden';
            form.appendChild(input);
        });
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }

    showLoading(message?: string) {
        this.loadingService.showLoading(message);
    }

    hideLoading() {
        this.loadingService.hideLoading()
    }

    getUrl(relativePath: string) {
        if (!window['iNet']) {
            return iNet.getPUrl(relativePath);
        }
        return relativePath;
    }
}
